/**
 * InstrumentsPanelWrapper Component
 * Wrapper for Virtual Instruments Panel
 */

import React from 'react';
import { InstrumentsPanel } from '../InstrumentsPanel';

export const InstrumentsPanelWrapper = ({
  isOpen,
  onClose,
  onNoteOn,
  onNoteOff,
  onDrumHit,
  activeNotes,
  activePads,
  isRecording,
  selectedInstrument,
  onInstrumentChange,
}) => {
  return (
    <InstrumentsPanel
      isOpen={isOpen}
      onClose={onClose}
      onNoteOn={onNoteOn}
      onNoteOff={onNoteOff}
      onDrumHit={onDrumHit}
      activeNotes={activeNotes}
      activePads={activePads}
      isRecording={isRecording}
      selectedInstrument={selectedInstrument}
      onInstrumentChange={onInstrumentChange}
    />
  );
};

export default InstrumentsPanelWrapper;
